<template>
  <div :key="keyRender">
    <ViewShowText v-if="showText" :componente="componente" />

    <ViewShowTimeSeries v-if="showTimeSeries" :componente="componente" />

    <ViewShowGraphical v-if="showGraphical" :componente="componente" />

    <ViewShowDial v-if="showDial" :componente="componente" />

    <ViewShowAction
      v-if="showAction"
      :componente="componente"
      :editable="editable"
    />

    <ViewShowImage
      v-if="showImage"
      :componente="componente"
      @loaded="$emit('loaded')"
    />

    <ViewShowTabelaSensorVirtualMensal
      v-if="showTabela"
      :local-id="localId"
      :componente="componente"
    />

    <ViewShowPipe
      v-if="showPipe"
      :componente="componente"
      :editable="editable"
      :selected="selected"
      @change="(v) => $emit('pipe-change', v)"
      @bodymove="(d) => $emit('pipe-bodymove', d)"
    />

    <ViewShowNavigation
      v-if="showNavigation"
      :local-id="localId"
      :componente="componente"
      :editable="editable"
    />
  </div>
</template>

<script>
import ViewShowTabelaSensorVirtualMensal from '@/components/view/component/ViewShowTabelaSensorVirtualMensal.vue'
import { ComponenteTipo } from '@/utils/componente'

import ViewShowAction from './component/ViewShowAction.vue'
import ViewShowDial from './component/ViewShowDial.vue'
import ViewShowGraphical from './component/ViewShowGraphical.vue'
import ViewShowImage from './component/ViewShowImage.vue'
import ViewShowNavigation from './component/ViewShowNavigation.vue'
import ViewShowPipe from './component/ViewShowPipe.vue'
import ViewShowText from './component/ViewShowText.vue'
import ViewShowTimeSeries from './component/ViewShowTimeSeries.vue'

export default {
  name: 'ViewComponenteShow',
  components: {
    ViewShowTabelaSensorVirtualMensal,
    ViewShowImage,
    ViewShowAction,
    ViewShowGraphical,
    ViewShowTimeSeries,
    ViewShowText,
    ViewShowDial,
    ViewShowPipe,
    ViewShowNavigation,
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      required: true,
    },
    componenteTipo: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyRender: 0,
    }
  },
  computed: {
    showText() {
      return this.componenteTipo === ComponenteTipo.TextView
    },
    showGraphical() {
      return this.componenteTipo === ComponenteTipo.GraphicalView
    },
    showImage() {
      return this.componenteTipo === ComponenteTipo.ImageView
    },
    showTimeSeries() {
      return this.componenteTipo === ComponenteTipo.TimeSeriesView
    },
    showDial() {
      return this.componenteTipo === ComponenteTipo.DialView
    },
    showAction() {
      return this.componenteTipo === ComponenteTipo.ActionView
    },
    showTabela() {
      return this.componenteTipo === ComponenteTipo.TabelaSensoresVirtuais
    },
    showPipe() {
      return this.componenteTipo === ComponenteTipo.PipeView
    },
    showNavigation() {
      return this.componenteTipo === ComponenteTipo.NavigationView
    },
  },
  watch: {
    componente() {
      this.updateKeyRender()
    },
  },
  methods: {
    updateKeyRender() {
      this.keyRender++
    },
  },
}
</script>

<style scoped></style>
